import { BFF_URL } from '../../lib/config';

export const getSsoLink = (type, target) => {
  return `${BFF_URL}/auth/${type}?target_uri=${target}`;
};